const initialState = {
	bikeLanding: {
        carYards: {},
        otherCities: {},
        currentBikePoint: {}
    },
	timeSlots: null
};

const bikeLanding = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_BIKE_CARS_DATA_SUCCESS':
		let carYard = {};
		let cityInventoryData = {};
		let allBikePoint = {};
		carYard[action.payload.subCategoryId] = action.payload.cityInventory;
		cityInventoryData[action.payload.subCategoryId] = action.payload.otherCitiesInventory;
		if(action.payload.currentBikePoint && action.payload.currentBikePoint.id) {
			allBikePoint[action.payload.currentBikePoint.id] = action.payload.currentBikePoint;
		}
			return {
                ...state,
                bikeLanding: {
                    ...state.bikeLanding,
                    carYards: { ...state.bikeLanding.carYards, ...carYard },
                    otherCities: { ...state.bikeLanding.otherCities, ...cityInventoryData },
                    currentBikePoint: { ...state.bikeLanding.currentBikePoint , ...allBikePoint },
                    cityId: action.payload.cityId,
                    cityName: action.payload.cityName,
                    categoryId: action.payload.categoryId,
                    subCategoryId: action.payload.subCategoryId,
                    subCategoryName: action.payload.subCategoryName,
                    title: action.payload.title,
                    cityList: action.payload.cityList,
                }
            };
			//return {...state, data:action.payload};
		case 'GET_BIKE_CARS_DATA_FAILURE':
			return Object.assign([],state, []);
		case 'GET_TIMESLOT_SUCCESS':
			 return {...state, timeSlots:action.payload};
		case 'GET_TIMESLOT_FAILURE':
			return Object.assign([],state, []);
		default:
			return state;
	}
};

export default bikeLanding;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/bikeLanding.js